import { Axios } from "./request";

const API_URL = "usersapi/v1/match/";

export const MATCH_API = {
  Search: (body, from, size) => {
    return Axios.post(`${API_URL}Search?from=${from}&size=${size}`, body);
  },
  ApproveMatchByMan: (profileNumber) => {
    return Axios.post(`${API_URL}ApproveMatchByMan?profileNumber=${profileNumber}`);
  },
  ApproveMatchByhWoman: (profileNumber) => {
    return Axios.post(`${API_URL}ApproveMatchByhWoman?profileNumber=${profileNumber}`);
  },
  RejectMatch: (profileNumber) => {
    return Axios.post(`${API_URL}RejectMatch?profileNumber=${profileNumber}`);
  },
  GetFirstContactTypes: () => {
    return Axios.get(`${API_URL}GetFirstContactTypes`);
  },
  SelectFirstContactType: (firstContactTypeCode) => {
    return Axios.post(
      `${API_URL}SelectFirstContactType?firstContactTypeCode=${firstContactTypeCode}`
    );
  },
  RejectMatchAndSearchAgainAfterRejectAllCandidates: (isSearchByBranch) => {
    return Axios.post(
      `${API_URL}RejectMatchAndSearchAgainAfterRejectAllCandidates?isSearchByBranch=${isSearchByBranch}`
    );
  },
  GetResultMeeting: () => {
    return Axios.get(`${API_URL}GetResultMeeting`);
  },
  AddResultMeeting: (body) => {
    return Axios.post(`${API_URL}AddResultMeeting`, body);
  },
  RejectMatchAndSearchAgain: (body, isSearchByBranch) => {
    return Axios.post(
      `${API_URL}RejectMatchAndSearchAgain?isSearchByBranch=${isSearchByBranch}`,
      body
    );
  },
  AcceptMatchAndContinue: (body) => {
    return Axios.post(`${API_URL}AcceptMatchAndContinue`, body);
  },
  AcceptFirstContactTypeChosen: () => {
    return Axios.post(`${API_URL}AcceptFirstContactTypeChosen`);
  },
  RegisterMarriage: (body) => {
    return Axios.post(`${API_URL}RegisterMarriage`, body);
  },
  GetResultMarriage: () => {
    return Axios.get(`${API_URL}GetResultMarriage`);
  },
};
